import { API_BASE_URL } from '../constants/api';
import api from './api';

export interface FileUploadResponse {
  id: string;
  name: string;
  size: number;
  type: string;
}

export interface FileUploadError {
  msg: string;
}

export interface FileDeleteResponse {
  success: boolean;
}

export class FileService {

  // Dosya yükleme (create)
  static async uploadFile(
    file: File,
    model: 'Talepler' | 'Bakimlar' | 'Kuponlar',
    masterId: number,
    thumb: boolean = true,
    previousFileId?: string
  ): Promise<FileUploadResponse> {
    const formData = new FormData();
    formData.append('upload', file);

    // Doğru endpoint format: /files/create/Talepler/129209/
    // XMLHttpRequest kullanarak session cookie'leri gönder
    return new Promise<FileUploadResponse>((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open('POST', `${API_BASE_URL}/files/create/${model}/${masterId}/`);

      // Session cookie'leri dahil et
      xhr.withCredentials = true;

      // Headers ekle
      xhr.setRequestHeader('X-File-Name', file.name);
      xhr.setRequestHeader('X-File-Size', file.size.toString());
      xhr.setRequestHeader('X-File-Type', file.type);

      xhr.onload = function () {
        if (xhr.status === 200) {
          try {
            const result = JSON.parse(xhr.responseText);

            // Hata varsa throw et
            if ('msg' in result) {
              reject(new Error((result as FileUploadError).msg));
            } else {
              resolve(result as FileUploadResponse);
            }
          } catch (error) {
            reject(new Error('Yanıt parse edilemedi'));
          }
        } else {
          reject(new Error(`HTTP error! status: ${xhr.status}`));
        }
      };

      xhr.onerror = function () {
        reject(new Error('Network error'));
      };

      xhr.send(formData);
    });
  }

  // Tek dosya silme (destroy)
  static async deleteFile(
    fileId: string,
    model: 'Talepler' | 'Bakimlar' | 'Kuponlar'
  ): Promise<FileDeleteResponse> {
    const formData = new FormData();
    formData.append('id', fileId);

    const response = await api.post<FileDeleteResponse>(
      `/files/destroy/${model}`,
      formData
    );

    return response.data;
  }

  // Tüm dosyaları silme (destroy)
  static async deleteAllFiles(
    model: 'Talepler' | 'Bakimlar' | 'Kuponlar',
    masterId: number
  ): Promise<FileDeleteResponse> {
    const formData = new URLSearchParams();
    formData.append('masterId', masterId.toString());

    const response = await api.post<FileDeleteResponse>(
      `/files/destroy/${model}`,
      formData
    );

    return response.data;
  }


  // Dosya URL'lerini oluşturmak için helper metodlar
  static getThumbnailUrl(fileId: string): string {
    return `${API_BASE_URL}/files/read/${fileId}`;
  }

  static getDownloadUrl(fileId: string): string {
    return `${API_BASE_URL}/files/download/${fileId}`;
  }
} 